import * as yup from 'yup'

import { JOB_REPORT_STATUSES } from '../../constants.js'
import { pageNum, pageSize, requiredString, string } from '../../yup/schemas.js'

import { jobSchema } from '../general.schema.js'
import { schoolSchema } from '../../school/schema.js'

const jobReportSchema = yup.object({
  id: requiredString.uuid(),
  status: requiredString.oneOf(Object.values(JOB_REPORT_STATUSES)),
  jobId: jobSchema.get('id'),
  schoolId: schoolSchema.get('id'),
  description: string
}).objectRequired()

const createJobReportSchema = jobReportSchema.pick(['description'])
const getJobReportListQueryParamsSchema = yup.object({
  pageNum,
  pageSize,
  status: jobReportSchema.get('status').optional(),
  schoolId: jobReportSchema.get('schoolId').optional(),
  jobId: jobReportSchema.get('jobId').optional()
}).objectRequired()
const getJobReportParamsSchema = jobReportSchema.pick(['id'])

const createJobReportSchemas = { front: createJobReportSchema, back: createJobReportSchema }
const getJobReportListQueryParamsSchemas = { front: getJobReportListQueryParamsSchema, back: getJobReportListQueryParamsSchema }
const getJobReportParamsSchemas = { front: getJobReportParamsSchema, back: getJobReportParamsSchema }

export default {
  createJobReport: createJobReportSchemas,
  getJobReportListQueryParams: getJobReportListQueryParamsSchemas,
  getJobReportParams: getJobReportParamsSchemas
}
